var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"father"},[(_vm.wtypermiss_show)?_c('wty-permission',{attrs:{"who":'peopleinfo',"perssionData":_vm.perssionData,"tableList":_vm.tableList,"tableClumn":_vm.peopleColumn}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }